import { render } from "./DropZonePage.vue?vue&type=template&id=276e7193&scoped=true"
import script from "./DropZonePage.vue?vue&type=script&lang=js"
export * from "./DropZonePage.vue?vue&type=script&lang=js"

import "./DropZonePage.vue?vue&type=style&index=0&id=276e7193&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276e7193"]])

export default __exports__